<template>
	<div id="content">
		<div class="box">
			<span v-if="queued">{{ $t('horse.indice_queued') }}</span>
			<CustomTable
				id_table="horse_indices"
				:items="indices"
				:busy.sync="table_busy"
				primaryKey="aptitude_id"
				:hide_if_empty="true"
			/>
		</div>
	</div>
</template>

<script type="text/javascript">
    import HorseMixin from "@/mixins/Horse.js"
	import Navigation from "@/mixins/Navigation.js"

	export default {
		name: 'Indice',
		mixins: [HorseMixin, Navigation],
		props: ['horse_id'],
		data () {
			return {
				table_busy: false,
				queued: false,
				indices: [],
				events_tab: {
					"TableAction::goToAskIndiceEmpty": () => {
						this.addHorsesIndiceQueue([this.horse_id])
					}
				}
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.table_busy = true
				const res = await this.loadHorseIndice(this.horse_id)
				this.queued = res.queued
				this.indices = res.indices
				this.table_busy = false
			},
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable')
		}
	}

</script>